import { Document, Page, Text, StyleSheet, View, Image } from '@react-pdf/renderer'
import moment from 'moment/moment';
import { romanize } from 'react-roman'


const PdfFile = ({userInfo}) => {
    // Create styles
    const styles = StyleSheet.create({
        page: {
            paddingHorizontal: 30,
            paddingVertical: 50,
            fontSize: 12,
            fontFamily: "Times-Roman"
          },
          viewer: {
            width: "100%",
            height: window.innerHeight,
          },
          header: {
            flexDirection: "row",
          },
          title: {
            textAlign: "center",
            width: 320,
            marginHorizontal: "auto",
            fontFamily: "Times-Bold",
            marginBottom: 20
          },
          section: {
            flexDirection: "column",
            gap: 4,
            marginBottom:20
          },
          sectionheader: {
            flexDirection: "row",
            gap: 20,
            
            marginBottom: 10,
            fontFamily: "Times-Bold"
          },
          secondsectionheader: {
            flexDirection: "row",
            gap: 20,
            marginBottom: 10,
          },
          heading: {
            flexDirection: "row",
            gap: 20,
            width: "50%",
          },
          datatitle: {
            flexDirection: "row",
          },
          datacontent:{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          },
          datadescription:{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginVertical:3
          },
          workdescription: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginVertical:3
          },
          subtitle: {
            textAlign: "center",
          },
          address: {
            fontSize: 12,
          },
          pageNumber: {
            position: 'absolute',
            fontSize: 12,
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: 'center',
          },
        });

    // const to_replace = new RegExp(*,'g');
    
    
  return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <View style={{ flex: 1 }}>
              <Text style={styles.title}>
                OBAFEMI AWOLOWO UNIVERSITY, ILE-IFE, NIGERIA CURRICULUM VITAE
              </Text>
            </View>
          </View>
          <View style={styles.sectionheader}>
            <Text style={{width:17}}>A.</Text><Text>PERSONAL DATA</Text>
          </View>
          <View style={styles.section}>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>1. </Text><Text style={{fontFamily: "Times-Bold"}}>Full Name:</Text>
                </View>
                <View style={{flexDirection:"row", gap:2, width:"50%"}}>
                    <Text style={{textTransform:"uppercase"}}>{userInfo?.users?.surname}</Text>
                    <Text style={{textTransform:"capitalize"}}> {userInfo?.users?.otherNames}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>2. </Text><Text style={{fontFamily: "Times-Bold"}}>Date and place of Birth:</Text>
                </View>
                <View>
                    <Text>{moment(userInfo?.users?.dob).format('Do MMMM, YYYY')} / {userInfo?.users?.pob}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17, marginBottom:3}}>3. </Text><Text style={{fontFamily: "Times-Bold"}}>Contact Details:</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{fontFamily: "Times-Bold"}}>(a) </Text><Text style={{fontFamily: "Times-Bold"}}>Residential Address:</Text></View>
                </View>
                <View style={{width:"50%"}}>
                    <Text>{userInfo?.users?.resAddress}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{color:"white",width:17}}>3. </Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{fontFamily: "Times-Bold"}}>(b) </Text><Text style={{fontFamily: "Times-Bold"}}>E-mail Address:</Text></View>
                </View>
                <View style={{width:"50%"}}>
                    <Text>{userInfo?.users?.email}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{color:"white",width:17}}>3. </Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{fontFamily: "Times-Bold"}}>(c) </Text><Text style={{fontFamily: "Times-Bold"}}>Mobile Telephone Number(s):</Text></View>
                </View>
                <View style={{width:"50%"}}>
                    <Text>{userInfo?.users?.telNumber}</Text>
                </View>
            </View>
            <View style={{marginTop:4}}></View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>4. </Text><Text style={{fontFamily: "Times-Bold"}}>Nationality:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users?.nationality}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>5. </Text><Text style={{fontFamily: "Times-Bold"}}>State of Origin:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users?.stateOfOrigin}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>6. </Text><Text style={{fontFamily: "Times-Bold"}}>Senatorial District:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users?.sen_district}</Text>
                </View>
            </View>

            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>7. </Text><Text style={{fontFamily: "Times-Bold"}}>Local Government Area:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users?.lga}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>8. </Text><Text style={{fontFamily: "Times-Bold"}}>Permanent Home Address:</Text>
                </View>
                <View style={{width:"50%"}}>
                    <Text>{userInfo?.users?.permHomeAdd}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>9. </Text><Text style={{fontFamily: "Times-Bold"}}>Marital Status:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users?.maritalStatus}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>10.</Text><Text style={{fontFamily: "Times-Bold"}}>Number of Children and their Ages:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users?.kids?.length}{userInfo?.users?.kids?.length > 0 ? "; (" : ""}
                    {
                        Array.apply(null, {length: userInfo?.users?.kids?.length}).map((e, i)=>(
                        <Text key={i}>
                            {userInfo?.users?.kids[i]} years{ i+1 !== userInfo?.users?.kids?.length ? ", " : ""}
                        </Text>
                    ))
                    }{userInfo?.users?.kids?.length > 0 ? ")" : ""}
                    </Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>11.</Text><Text style={{fontFamily: "Times-Bold"}}>Next of Kin:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users_extra?.nextOfKinName}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>12.</Text><Text style={{fontFamily: "Times-Bold"}}>Contact Details of Next of Kin:</Text>
                </View>
                
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{fontFamily: "Times-Bold"}}>(a) </Text><Text style={{fontFamily: "Times-Bold"}}>Residential Address:</Text></View>
                </View>
                <View style={{width:"50%"}}>
                    <Text>{userInfo?.users_extra?.nextOfKinResAddress}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{fontFamily: "Times-Bold"}}>(b) </Text><Text style={{fontFamily: "Times-Bold"}}>E-mail Address:</Text></View>
                </View>
                <View style={{width:"50%"}}>
                    <Text>{userInfo?.users_extra?.nextOfKinEmail}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{fontFamily: "Times-Bold"}}>(c) </Text><Text style={{fontFamily: "Times-Bold"}}>Mobile Telephone Number(s):</Text></View>
                </View>
                <View style={{width:"50%"}}>
                    <Text>{userInfo?.users_extra?.telNoNextOfKin}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>13. </Text><Text style={{fontFamily: "Times-Bold"}}>Date of Assumption of Duty:</Text>
                </View>
                <View>
                    <Text>{moment(userInfo?.users_extra?.dOfAssumptionOfDuty).format('Do MMMM, YYYY')}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>14. </Text><Text style={{fontFamily: "Times-Bold"}}>Rank/Status on First Appointment:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users_extra?.firstRank}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>15. </Text><Text style={{fontFamily: "Times-Bold"}}>Present Status:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users_extra?.currentStatus}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>16. </Text><Text style={{fontFamily: "Times-Bold"}}>Present Salary Grade Level and Step:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users_extra?.salaryGrade}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>17. </Text><Text style={{fontFamily: "Times-Bold"}}>Date of Last Promotion/Regrading:</Text>
                </View>
                <View>
                    <Text>{moment(userInfo?.users_extra?.dOfLastPromotion).format('Do MMMM, YYYY')}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>18. </Text><Text style={{fontFamily: "Times-Bold"}}>Date of Confirmation of Appointment:</Text>
                </View>
                <View>
                    <Text>{moment(userInfo?.users_extra?.dOfConfirmAppointment).format('Do MMMM, YYYY')}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>19. </Text><Text style={{fontFamily: "Times-Bold"}}>Faculty/Directorate:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users_extra?.fac_direc}</Text>
                </View>
            </View>
            <View style={styles.datatitle}>
                <View style={styles.heading}>
                    <Text style={{width:17}}>20. </Text><Text style={{fontFamily: "Times-Bold"}}>Department/Unit:</Text>
                </View>
                <View>
                    <Text>{userInfo?.users_extra?.dept_unit}</Text>
                </View>
            </View>
          </View>
          <View style={styles.sectionheader}>
            <Text style={{width:17}}>B.</Text><Text>EDUCATIONAL BACKGROUND</Text>
          </View>
            <View style={styles.section}>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>1.</Text><Text style={{fontFamily: "Times-Bold"}}>Higher Educational Institutions Attended with Dates:</Text>
                    </View>
                </View>
                {
                        Array.apply(null, {length: userInfo?.educational_col?.eduInstitutions?.length}).map((e, i)=>(
                        <View key={i} style={styles.datacontent}>
                            <View style={styles.heading}>
                                <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{textTransform:"lowercase"}}>({romanize(i+1)}) </Text><Text style={{}}>{userInfo?.educational_col?.eduInstitutions[i]?.school+", "+userInfo?.educational_col?.eduInstitutions[i]?.city+", "+userInfo?.educational_col?.eduInstitutions[i]?.country}, </Text></View>
                            </View>
                            <View style={{width:70, textAlign:'right'}}>
                                <Text>{moment(userInfo?.educational_col?.eduInstitutions[i]?.start).format("YYYY")+" - "+moment(userInfo?.educational_col?.eduInstitutions[i]?.stop).format("YYYY")}</Text>
                            </View>
                        </View>
                    ))
                }
                {/* <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{}}>(i) </Text><Text style={{}}>{}</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>2017 - 2021</Text>
                    </View>
                </View> */}
            </View>
            <View style={styles.section}>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>2.</Text><Text style={{fontFamily: "Times-Bold"}}>Academic/ Professional Qualifications and Distinctions Obtained with Dates:</Text>
                    </View>
                </View>
                {
                    Array.apply(null, {length: userInfo?.educational_col?.eduInstitutions?.length}).map((e, i)=>(
                    <View style={styles.datacontent}>
                        <View key={i} style={styles.heading}>
                            <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{textTransform:"lowercase"}}>({romanize(i+1)}) </Text><Text style={{}}>{userInfo?.educational_col?.eduInstitutions[i]?.qualification+" ("+userInfo?.educational_col?.eduInstitutions[i]?.field+")"} </Text></View>
                        </View>
                        <View style={{width:70, textAlign:'right'}}>
                            <Text>{moment(userInfo?.educational_col?.eduInstitutions[i]?.start).format("YYYY")+" - "+moment(userInfo?.educational_col?.eduInstitutions[i]?.stop).format("YYYY")}</Text>
                        </View>
                    </View>
                    ))
                }
                {/* <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{}}>(i) </Text><Text style={{}}>Redeemers University</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>2017 - 2021</Text>
                    </View>
                </View> */}
            </View>
            <View style={styles.section}>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>3.</Text><Text style={{fontFamily: "Times-Bold"}}>Other Distinctions and Awards with Dates:</Text>
                    </View>
                </View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{}}>(a) </Text><Text style={{fontFamily: "Times-Bold"}}>Scholarships</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{ userInfo?.educational_col?.scholarships[0] === null || userInfo?.educational_col?.scholarships[0] === undefined ? "Nil" : null}</Text>
                    </View>
                </View>
                {
                    userInfo?.educational_col?.scholarships[0] === null || userInfo?.educational_col?.scholarships[0] === undefined ? null : Array.apply(null, {length: userInfo?.educational_col?.scholarships?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.educational_col?.scholarships[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{}}>(b) </Text><Text style={{fontFamily: "Times-Bold"}}>Fellowships</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.educational_col?.fellowships[0] === null || userInfo?.educational_col?.fellowships[0] === undefined  ? "Nil" : null}</Text>
                    </View>
                </View>
                {
                    userInfo?.educational_col?.fellowships[0] === null || userInfo?.educational_col?.fellowships[0] === undefined ? null : Array.apply(null, {length: userInfo?.educational_col?.fellowships?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.educational_col?.fellowships[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View> 
                    ))
                }
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{}}>(c) </Text><Text style={{fontFamily: "Times-Bold"}}>Research Grants</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.educational_col?.resGrants[0] === null || userInfo?.educational_col?.resGrants[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.educational_col?.resGrants[0] === null || userInfo?.educational_col?.resGrants[0] === undefined ? null : Array.apply(null, {length: userInfo?.educational_col?.resGrants?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.educational_col?.resGrants[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{}}>(d) </Text><Text style={{fontFamily: "Times-Bold"}}>National Awards</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.educational_col?.natAwards[0] === null || userInfo?.educational_col?.natAwards[0] === undefined ? "Nil" : null}</Text>
                    </View>
                </View>
                {
                    userInfo?.educational_col?.natAwards[0] === null || userInfo?.educational_col?.natAwards[0] === undefined ? null : Array.apply(null, {length: userInfo?.educational_col?.natAwards?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.educational_col?.natAwards[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 20}}> <Text style={{}}>(e) </Text><Text style={{fontFamily: "Times-Bold"}}>International Awards</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.educational_col?.intAwards[0] === null || userInfo?.educational_col?.intAwards[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.educational_col?.intAwards[0] === null || userInfo?.educational_col?.intAwards[0] === undefined ? null : Array.apply(null, {length: userInfo?.educational_col?.intAwards?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.educational_col?.intAwards[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
            </View>

        <View style={styles.sectionheader}>
            <Text style={{width:17}}>C.</Text><Text>WORK EXPERIENCE WITH DATES</Text>
        </View>
            <View style={styles.section}>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>1.</Text><Text style={{fontFamily: "Times-Bold"}}>Previous Work Experience Outside the University System:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.work_exp?.pWOutSideUni[0] === null || userInfo?.work_exp?.pWOutSideUni[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.work_exp?.pWOutSideUni[0] === null || userInfo?.work_exp?.pWOutSideUni[0] === undefined ? null : Array.apply(null, {length: userInfo?.work_exp?.pWOutSideUni?.length}).map((e, i)=>(
                        <View style={styles.workdescription}>
                            <View style={{flexDirection: "row", gap: 20, width:"100%"}}>
                                <Text style={{color:"white",width:20}}>3.</Text>
                                <View style={{flexDirection: "row",width:"100%", gap:15}}>
                                    <View style={{flexDirection: "row",gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)}) </Text><Text style={{}}>{userInfo?.work_exp?.pWOutSideUni[i].title+ ", "+userInfo?.work_exp?.pWOutSideUni[i].organization+", "+userInfo?.work_exp?.pWOutSideUni[i].city+", "+userInfo?.work_exp?.pWOutSideUni[i].state}</Text> </View>
                                    <View style={{width:70, textAlign:'right',}}><Text>{moment(userInfo?.work_exp?.pWOutSideUni[i]?.start).format("YYYY")+" - "+moment(userInfo?.work_exp?.pWOutSideUni[i]?.stop).format("YYYY")}</Text></View>
                                </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>2.</Text><Text style={{fontFamily: "Times-Bold"}}>Previous Work Experience in Other Universities:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.work_exp?.pWOutsideOAU[0] === null || userInfo?.work_exp?.pWOutsideOAU[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.work_exp?.pWOutsideOAU[0] === null || userInfo?.work_exp?.pWOutsideOAU[0] === undefined ? null : Array.apply(null, {length: userInfo?.work_exp?.pWOutsideOAU?.length}).map((e, i)=>(
                        <View style={styles.workdescription}>
                            <View style={{flexDirection: "row", gap: 20, width:"100%"}}>
                                <Text style={{color:"white",width:20}}>3.</Text>
                                <View style={{flexDirection: "row",width:"100%", gap:15}}>
                                    <View style={{flexDirection: "row",gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)}) </Text><Text style={{}}>{userInfo?.work_exp?.pWOutsideOAU[i].title+ ", "+userInfo?.work_exp?.pWOutsideOAU[i].university+", "+userInfo?.work_exp?.pWOutsideOAU[i].city+", "+userInfo?.work_exp?.pWOutsideOAU[i].state}</Text> </View>
                                    <View style={{width:70, textAlign:'right',}}><Text>{moment(userInfo?.work_exp?.pWOutsideOAU[i]?.start).format("YYYY")+" - "+moment(userInfo?.work_exp?.pWOutsideOAU[i]?.stop).format("YYYY")}</Text></View>
                                </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>3.</Text><Text style={{fontFamily: "Times-Bold"}}>Work Experience in Obafemi Awolowo University:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.work_exp?.wInOAU[0] === null || userInfo?.work_exp?.wInOAU[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.work_exp?.wInOAU[0] === null || userInfo?.work_exp?.wInOAU[0] === undefined ? null : Array.apply(null, {length: userInfo?.work_exp?.wInOAU?.length}).map((e, i)=>(
                        <View style={styles.workdescription}>
                            <View style={{flexDirection: "row", gap: 20, width:"100%"}}>
                                <Text style={{color:"white",width:20}}>3.</Text>
                                <View style={{flexDirection: "row",width:"100%", gap:15}}>
                                    <View style={{flexDirection: "row",gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)}) </Text><Text style={{}}>{userInfo?.work_exp?.wInOAU[i].title+ ", "+userInfo?.work_exp?.wInOAU[i].department}</Text> </View>
                                    <View style={{width:70, textAlign:'right',}}><Text>{moment(userInfo?.work_exp?.wInOAU[i]?.start).format("YYYY")+" - "+moment(userInfo?.work_exp?.wInOAU[i]?.stop).format("YYYY")}</Text></View>
                                </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>4.</Text><Text style={{fontFamily: "Times-Bold"}}>Courses Taught within the Current Academic Session:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.work_exp?.coursesTaught[0]?.title === null || userInfo?.work_exp?.coursesTaught[0]?.title === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.work_exp?.coursesTaught[0]?.title === null || userInfo?.work_exp?.coursesTaught[0]?.title === undefined ? null : Array.apply(null, {length: userInfo?.work_exp?.coursesTaught?.length}).map((e, i)=>(
                        <View style={styles.workdescription}>
                            <View style={{flexDirection: "row", gap: 20, width:"100%"}}>
                                <Text style={{color:"white",width:20}}>3.</Text>
                                <View style={{flexDirection: "row",width:"100%", gap:15}}>
                                    <View style={{flexDirection: "row",gap: 10, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})</Text><Text style={{width:70}}>&nbsp; {userInfo?.work_exp?.coursesTaught[i].code}</Text><Text style={{width:"100%"}}>{userInfo?.work_exp?.coursesTaught[i].title}</Text> </View>
                                    <View style={{width:70, textAlign:'right',}}><Text>{userInfo?.work_exp?.coursesTaught[i].mode}</Text></View>
                                </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>5.</Text><Text style={{fontFamily: "Times-Bold"}}>Graduate Student Supervision:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text></Text>
                    </View>
                </View>
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 9}}><Text style={{width:30}}>(a)</Text><Text style={{fontFamily: "Times-Bold"}}>By Research</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.work_exp?.gStudSupervision_research[0] === null || userInfo?.work_exp?.gStudSupervision_research[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.work_exp?.gStudSupervision_research[0] === null || userInfo?.work_exp?.gStudSupervision_research[0] === undefined ? null : Array.apply(null, {length: userInfo?.work_exp?.gStudSupervision_research?.length}).map((e, i)=>(
                        <View style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text>
                                    <View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})</Text>
                                        <View style={{flexDirection: "row", gap:9, width:"100%", justifyContent:"space-between"}}>
                                            <Text style={{width:"100%"}}>
                                                {userInfo?.work_exp?.gStudSupervision_research[i].name + ", "+ userInfo?.work_exp?.gStudSupervision_research[i].matricNo + ", "+ userInfo?.work_exp?.gStudSupervision_research[i].topic}
                                            </Text>
                                            <Text style={{width:70, textAlign:'right'}}>{userInfo?.work_exp?.gStudSupervision_research[i].status}</Text>
                                        </View>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 9}}><Text style={{width:30}}>(b)</Text><Text style={{fontFamily: "Times-Bold"}}>By Long Essay</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.work_exp?.gStudSupervision_essay[0] === null || userInfo?.work_exp?.gStudSupervision_essay[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.work_exp?.gStudSupervision_essay[0] === null || userInfo?.work_exp?.gStudSupervision_essay[0] === undefined ? null : Array.apply(null, {length: userInfo?.work_exp?.gStudSupervision_essay?.length}).map((e, i)=>(
                        <View style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text>
                                    <View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})</Text>
                                        <View style={{flexDirection: "row", gap:9, width:"100%", justifyContent:"space-between"}}>
                                            <Text style={{width:"100%"}}>
                                                {userInfo?.work_exp?.gStudSupervision_essay[i].name + ", "+ userInfo?.work_exp?.gStudSupervision_essay[i].matricNo + ", "+ userInfo?.work_exp?.gStudSupervision_essay[i].topic}
                                            </Text>
                                            <Text style={{width:70, textAlign:'right'}}>{userInfo?.work_exp?.gStudSupervision_essay[i].status}</Text>
                                        </View>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                </View>
                {/* <View><Text> </Text></View> */}
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>6.</Text><Text style={{fontFamily: "Times-Bold"}}>Undergraduate Student Supervision:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.work_exp?.noCurrentStudents}</Text>
                    </View>
                </View>
            <View style={{marginVertical: 3}}><Text> </Text></View>
            <View style={styles.secondsectionheader}>
                <Text style={{width:17, fontFamily:"Times-Bold"}}>D.</Text>
                <View style={{width:"100%", flexDirection:"row", justifyContent:'space-between'}}>
                    <Text style={{fontFamily:"Times-Bold"}}>MEMBERSHIP OF PROFESSIONAL BODIES WITH DATES:</Text>
                    <View style={{width:70, textAlign:'right', fontFamily:"Times-Roman"}}>
                        <Text>{ userInfo?.publications?.profMembership[0] === null || userInfo?.publications?.profMembership[0] === undefined ? "Nil" : null}</Text>
                    </View>
                </View>   
            </View>
                {
                    userInfo?.publications?.profMembership[0] === null || userInfo?.publications?.profMembership[0] === undefined ? null : Array.apply(null, {length: userInfo?.publications?.profMembership?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.profMembership[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
            <View style={{marginVertical: 3}}><Text> </Text></View>
            <View style={styles.sectionheader}>
                <Text style={{width:17}}>E.</Text><Text>PUBLICATIONS:</Text>
            </View>
            <View style={styles.section}>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>1.</Text><Text style={{fontFamily: "Times-Bold"}}>Theses/Dissertations:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.thesisDissertations[0]?.authors === null || userInfo?.publications?.thesisDissertations[0]?.authors === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.thesisDissertations[0]?.authors === null || userInfo?.publications?.thesisDissertations[0]?.authors === undefined ? null : Array.apply(null, {length: userInfo?.publications?.thesisDissertations?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.thesisDissertations[i]?.authors+" ("+userInfo?.publications?.thesisDissertations[i]?.year+"): "+ userInfo?.publications?.thesisDissertations[i].title}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>2.</Text><Text style={{fontFamily: "Times-Bold"}}>Books and Monographs:</Text>
                    </View>
                </View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 9}}><Text style={{width:30}}>(a)</Text><Text style={{fontFamily: "Times-Bold"}}>Authored</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.bm_authored[0] === null || userInfo?.publications?.bm_authored[0] === undefined || userInfo?.publications?.bm_authored[0] === "" ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.bm_authored[0] === null || userInfo?.publications?.bm_authored[0] === undefined || userInfo?.publications?.bm_authored[0] === "" ? null : Array.apply(null, {length: userInfo?.publications?.bm_authored?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.bm_authored[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 9}}><Text style={{width:30}}>(b)</Text><Text style={{fontFamily: "Times-Bold"}}>Edited</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.bm_edited[0] === null || userInfo?.publications?.bm_edited[0] === undefined || userInfo?.publications?.bm_edited[0] === "" ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.bm_edited[0] === null || userInfo?.publications?.bm_edited[0] === undefined || userInfo?.publications?.bm_edited[0] === "" ? null : Array.apply(null, {length: userInfo?.publications?.bm_edited?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.bm_edited[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>3.</Text><Text style={{fontFamily: "Times-Bold"}}>Contribution to Books:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.bookContributions === null || userInfo?.publications?.bookContributions === undefined || userInfo?.publications?.bookContributions === "" ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.bookContributions === null || userInfo?.publications?.bookContributions === undefined || userInfo?.publications?.bookContributions === "" ? null : Array.apply(null, {length: userInfo?.publications?.bookContributions?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.bookContributions[i].Authors + " ("+userInfo?.publications?.bookContributions[i].Year+ "). "+userInfo?.publications?.bookContributions[i].Title
                                        +"in "+userInfo?.publications?.bookContributions[i].Book
                                        + ", " +userInfo?.publications?.bookContributions[i].Editors+" (Eds.), "+userInfo?.publications?.bookContributions[i].Page+". ISBN: "+
                                        userInfo?.publications?.bookContributions[i].ISBN + ", " + userInfo?.publications?.bookContributions[i].Publisher +". "+ userInfo?.publications?.bookContributions[i].Country
                                        }
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>4.</Text><Text style={{fontFamily: "Times-Bold"}}>Published Journals:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.publishedJournals === null || userInfo?.publications?.publishedJournals === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.publishedJournals === null || userInfo?.publications?.publishedJournals === undefined ? null : Array.apply(null, {length: userInfo?.publications?.publishedJournals?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.publishedJournals[i].Authors.split(",").map((author, i, authorList)=>(
                                            author.indexOf("*")!==-1  ? <Text style={{fontFamily:"Times-Bold"}}>{author.replaceAll("*", "")}<Text style={{fontFamily:"Times-Roman"}}>{ i+1 === authorList.length ?  "" : i+2 === authorList.length ?  " &" : ","}</Text></Text> 
                                            : 
                                            <Text>{author}{i+1 === authorList.length ?  "" : i+2 === authorList.length ?  " &" : ","}</Text>     
                                        ))}
                                        <Text>{" ("+userInfo?.publications?.publishedJournals[i].Year+ "); "+userInfo?.publications?.publishedJournals[i].Article+". "}
                                            </Text><Text style={{fontFamily:"Times-Italic"}}>{userInfo?.publications?.publishedJournals[i].Journal +", "}</Text><Text>
                                            {userInfo?.publications?.publishedJournals[i].Volume+" ("+userInfo?.publications?.publishedJournals[i].Issue+"): "+userInfo?.publications?.publishedJournals[i].Page+", DOI: "+
                                            userInfo?.publications?.publishedJournals[i].DOI + ". (" + userInfo?.publications?.publishedJournals[i].Country +")"} 
                                        </Text>
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>5.</Text><Text style={{fontFamily: "Times-Bold"}}>Edited and Refereed Conference Proceedings:</Text>
                    </View>
                </View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 9}}><Text style={{width:30}}>(a)</Text><Text style={{fontFamily: "Times-Bold"}}>Authored</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.refConferenceProceedings === null || userInfo?.publications?.refConferenceProceedings === undefined || userInfo?.publications?.refConferenceProceedings === "" ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.refConferenceProceedings === null || userInfo?.publications?.refConferenceProceedings === undefined ? null : Array.apply(null, {length: userInfo?.publications?.refConferenceProceedings?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {
                                            userInfo?.publications?.refConferenceProceedings[i].Authors + " ("+userInfo?.publications?.refConferenceProceedings[i].Year+ "); '"+userInfo?.publications?.refConferenceProceedings[i].Title
                                            +"', In "+userInfo?.publications?.refConferenceProceedings[i].Editors + " (Eds), " +userInfo?.publications?.refConferenceProceedings[i].Conference
                                            + ", " +userInfo?.publications?.refConferenceProceedings[i].Town+", "+userInfo?.publications?.refConferenceProceedings[i].Country+", p. "+userInfo?.publications?.refConferenceProceedings[i].Page
                                        }
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datacontent}>
                    <View style={styles.heading}>
                        <Text style={{color:"white",width:17}}>3.</Text><View style={{flexDirection: "row",gap: 9}}><Text style={{width:30}}>(b)</Text><Text style={{fontFamily: "Times-Bold"}}>Edited</Text></View>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.nonRefConferenceProceedings === null || userInfo?.publications?.nonRefConferenceProceedings === undefined || userInfo?.publications?.nonRefConferenceProceedings === "" ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.nonRefConferenceProceedings === null || userInfo?.publications?.nonRefConferenceProceedings === undefined ? null : Array.apply(null, {length: userInfo?.publications?.nonRefConferenceProceedings?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.nonRefConferenceProceedings[i].Authors + " ("+userInfo?.publications?.nonRefConferenceProceedings[i].Year+ "); '"+userInfo?.publications?.nonRefConferenceProceedings[i].Title
                                            +"', In "+userInfo?.publications?.nonRefConferenceProceedings[i].Editors + " (Eds), " +userInfo?.publications?.nonRefConferenceProceedings[i].Conference
                                            + ", " +userInfo?.publications?.nonRefConferenceProceedings[i].Town+", "+userInfo?.publications?.nonRefConferenceProceedings[i].Country+", p. "+userInfo?.publications?.nonRefConferenceProceedings[i].Page}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>6.</Text><Text style={{fontFamily: "Times-Bold"}}>Articles Accepted for Publication:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.publicationsArticles === null || userInfo?.publications?.publicationsArticles === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.publicationsArticles === null || userInfo?.publications?.publicationsArticles === undefined ? null : Array.apply(null, {length: userInfo?.publications?.publicationsArticles?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.publicationsArticles[i].Authors} 
                                        { " ("+userInfo?.publications?.publicationsArticles[i].Year+ "); "+userInfo?.publications?.publicationsArticles[i].Title
                                        // + ", " + userInfo?.publications?.publishedJournals[i].Country
                                        }
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>7.</Text><Text style={{fontFamily: "Times-Bold"}}>Manuscripts Submitted for Publication:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.publicationManucript === null || userInfo?.publications?.publicationManucript === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.publicationManucript === null || userInfo?.publications?.publicationManucript === undefined ? null : Array.apply(null, {length: userInfo?.publications?.publicationManucript?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.publicationManucript[i].Authors + ", "+userInfo?.publications?.publicationsArticles[i].Title
                                        + ". "
                                        }
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>8.</Text><Text style={{fontFamily: "Times-Bold"}}>Creative Works/Patents:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.patents === null || userInfo?.publications?.patents === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.patents === null || userInfo?.publications?.patents === undefined ? null : Array.apply(null, {length: userInfo?.publications?.patents?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.patents[i].Authors + ", "+userInfo?.publications?.patents[i].Title
                                        + ". "
                                        }
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>9.</Text><Text style={{fontFamily: "Times-Bold"}}>Technical Report:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.technicalReports === null || userInfo?.publications?.technicalReports === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.technicalReports === null || userInfo?.publications?.technicalReports === undefined ? null : Array.apply(null, {length: userInfo?.publications?.technicalReports?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.technicalReports[i].Authors + " ("+userInfo?.publications?.technicalReports[i].Year+ "). "+userInfo?.publications?.technicalReports[i].Title+ "."
                                        + ". "
                                        }
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>10.</Text><Text style={{fontFamily: "Times-Bold"}}>Papers and Works in Progress:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.publications?.pWInProgress[0] === null || userInfo?.publications?.pWInProgress[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.publications?.pWInProgress[0] === null || userInfo?.publications?.pWInProgress[0] === undefined ? null : Array.apply(null, {length: userInfo?.publications?.pWInProgress?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.publications?.pWInProgress[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
            </View>
            <View style={styles.sectionheader}>
                <Text style={{width:17}}>F.</Text><Text>PROFESSIONAL ACCOMPLISHMENTS</Text>
            </View>
            <View style={styles.section}>
                <View style={styles.datadescription}>
                    <View style={{width:"100%", flexDirection: "row", gap:20}}>
                        <Text style={{width:18, color:"white"}}>3. </Text><View style={{width:"100%"}}>
                            <Text style={{width:"100%"}}>
                                {userInfo?.accomplishments?.profAccomplishments}
                            </Text>
                            </View>
                    </View>
                </View>
            </View>
            <View style={styles.secondsectionheader}>
                <Text style={{width:17, fontFamily:"Times-Bold"}}>G.</Text>
                <View style={{width:"100%", flexDirection:"row", justifyContent:'space-between'}}>
                    <Text style={{fontFamily:"Times-Bold"}}>CONFERENCES, SEMINARS AND WORKSHOPS ATTENDED WITH DATES:</Text>
                    <View style={{width:70, textAlign:'right', fontFamily:"Times-Roman"}}>
                        <Text>{ userInfo?.accomplishments?.seminarsWorkshops[0] === null || userInfo?.accomplishments?.seminarsWorkshops[0] === undefined ? "Nil" : null}</Text>
                    </View>
                </View>   
            </View>
                {
                    userInfo?.accomplishments?.seminarsWorkshops[0] === null || userInfo?.accomplishments?.seminarsWorkshops[0] === undefined ? null : Array.apply(null, {length: userInfo?.accomplishments?.seminarsWorkshops?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.accomplishments?.seminarsWorkshops[i]}
                                        </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
            <View style={{marginVertical: 3}}></View>
            <View style={styles.secondsectionheader}>
                <Text style={{width:17, fontFamily:"Times-Bold"}}>H.</Text>
                <View style={{width:"100%", flexDirection:"row", justifyContent:'space-between'}}>
                    <Text style={{fontFamily:"Times-Bold"}}>CURRENT RESEARCH ACTIVITIES:</Text>
                    <View style={{width:70, textAlign:'right', fontFamily:"Times-Roman"}}>
                        <Text>{ userInfo?.accomplishments?.researchActivities[0] === null || userInfo?.accomplishments?.researchActivities[0] === undefined ? "Nil" : null}</Text>
                    </View>
                </View>   
            </View>
                {
                    userInfo?.accomplishments?.researchActivities[0] === null || userInfo?.accomplishments?.researchActivities[0] === undefined ? null : Array.apply(null, {length: userInfo?.accomplishments?.researchActivities?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.accomplishments?.researchActivities[i]}
                                        </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
            <View style={{marginVertical: 3}}></View>
            <View style={styles.sectionheader}>
                <Text style={{width:17}}>I.</Text><Text>OTHER RELEVANT INFORMATION</Text>
            </View>
             <View style={styles.section}>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>1.</Text><Text style={{fontFamily: "Times-Bold"}}>Services within the Department/Institute:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.knowledge_contrib?.deptServices[0] === null || userInfo?.knowledge_contrib?.deptServices[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.knowledge_contrib?.deptServices[0] === null || userInfo?.knowledge_contrib?.deptServices[0] === undefined ? null : Array.apply(null, {length: userInfo?.knowledge_contrib?.deptServices?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.knowledge_contrib?.deptServices[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>2.</Text><Text style={{fontFamily: "Times-Bold"}}>Services within the Faculty:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.knowledge_contrib?.facultyServices[0] === null || userInfo?.knowledge_contrib?.facultyServices[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.knowledge_contrib?.facultyServices[0] === null || userInfo?.knowledge_contrib?.facultyServices[0] === undefined ? null : Array.apply(null, {length: userInfo?.knowledge_contrib?.facultyServices?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.knowledge_contrib?.facultyServices[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>3.</Text><Text style={{fontFamily: "Times-Bold"}}>Services within the Univeristy:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.knowledge_contrib?.uniServices[0] === null || userInfo?.knowledge_contrib?.uniServices[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.knowledge_contrib?.uniServices[0] === null || userInfo?.knowledge_contrib?.uniServices[0] === undefined ? null : Array.apply(null, {length: userInfo?.knowledge_contrib?.uniServices?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.knowledge_contrib?.uniServices[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
                <View></View>
                <View style={styles.datatitle}>
                    <View style={{flexDirection:"row", gap:20, width:"100%"}}>
                        <Text style={{width:17}}>4.</Text><Text style={{fontFamily: "Times-Bold"}}>Services outside the Univeristy:</Text>
                    </View>
                    <View style={{width:70, textAlign:'right'}}>
                        <Text>{userInfo?.knowledge_contrib?.servicesOutsideUni[0] === null || userInfo?.knowledge_contrib?.servicesOutsideUni[0] === undefined ? "Nil" : null }</Text>
                    </View>
                </View>
                {
                    userInfo?.knowledge_contrib?.servicesOutsideUni[0] === null || userInfo?.knowledge_contrib?.servicesOutsideUni[0] === undefined ? null : Array.apply(null, {length: userInfo?.knowledge_contrib?.servicesOutsideUni?.length}).map((e, i)=>(
                        <View key={i} style={styles.datadescription}>
                            <View style={{width:"100%", flexDirection: "row", gap:20}}>
                                <Text style={{width:18, color:"white"}}>3. </Text><View style={{flexDirection: "row", gap: 9, width:"100%"}}><Text style={{textTransform:"lowercase", width:30}}>({romanize(i+1)})  </Text>
                                    <Text style={{width:"100%"}}>
                                        {userInfo?.knowledge_contrib?.servicesOutsideUni[i]}
                                    </Text>
                                    </View>
                            </View>
                        </View>
                    ))
                }
            
            </View> 
            <View style={styles.sectionheader}>
                <Text style={{width:17}}>J.</Text><Text>CONTRIBUTION TO KNOWLEDGE</Text>
            </View>
            <View style={styles.section}>
                <View style={styles.datadescription}>
                    <View style={{width:"100%", flexDirection: "row", gap:20}}>
                        <Text style={{width:18, color:"white"}}>3. </Text><View style={{width:"100%"}}>
                            <Text style={{width:"100%"}}>
                                {userInfo?.knowledge_contrib?.contribToKnowledge}
                            </Text>
                            </View>
                    </View>
                </View>
            </View>

            <View style={{flexDirection: "row", justifyContent: "space-evenly", alignItems:"flex-end", width:"100%", marginTop: 20}}>
                <View style={{flexDirection: "column", alignItems:"flex-end"}}>
                    <Image src={userInfo?.knowledge_contrib?.signature} style={{width:70, height:60, marginBottom:-15, marginRight:7}} />
                    <Text>Signature..........................</Text>
                </View>
                <View >

                    <Text>Date: {moment(userInfo?.knowledge_contrib?.dateOfSubmission).format('D-MM-YYYY')}</Text>
                </View>
            </View>
            <Text style={styles.pageNumber} render={({ pageNumber }) => (
                `${pageNumber}`
            )} fixed />
            {/* <View style={{width: "100%", alignSelf:"center"}}></View> */}
        </Page>
      </Document>
    
  )
}

export default PdfFile